module.exports = __webpack_public_path__ + "img/sshx.52a7098a.png";